import type { EffectDefinition, VideoEffect } from './types';

/**
 * Central effect registry (Phase 1, Step 1).
 * Every effect type and runtime instance plugs into the same system.
 */

/** Timeline JSON type aliases (e.g. `"sunshine"` → `sun_rays`). */
export const EFFECT_TYPE_ALIASES: Record<string, string> = {
  sunshine: 'sun_rays',
  god_rays: 'sun_rays',
};

export function normalizeEffectType(type: string): string {
  return EFFECT_TYPE_ALIASES[type] || type;
}

export class EffectRegistry {
  private readonly definitions = new Map<string, EffectDefinition>();
  private readonly instances = new Map<string, VideoEffect>();

  registerDefinition(def: EffectDefinition): void {
    this.definitions.set(def.type, def);
  }

  registerInstance(effect: VideoEffect): void {
    this.instances.set(effect.id, effect);
  }

  unregisterInstance(id: string): void {
    this.instances.delete(id);
  }

  getDefinition(type: string): EffectDefinition | undefined {
    return this.definitions.get(type);
  }

  getInstance(id: string): VideoEffect | undefined {
    return this.instances.get(id);
  }

  listDefinitions(): EffectDefinition[] {
    return Array.from(this.definitions.values());
  }

  listInstances(): VideoEffect[] {
    return Array.from(this.instances.values());
  }
}

export const globalEffectRegistry = new EffectRegistry();
